import {TimelineMax, TweenMax, Linear} from 'gsap';
const EventEmitter = require('eventemitter3');
const AnimationPlayer = require('../animations/AnimationPlayer');
const DefaultLottieConstruct = require('../animations/constructors/DefaultLottieConstruct');
const BgConstruct = require('../animations/constructors/BgConstruct');
const DefaultResizeBehavior = require('../animations/behaviors/DefaultResizeBehavior');
const OrientationResizeBehavior = require('../animations/behaviors/OrientationResizeBehavior');
const InvertChildrenTransformBehavior = require('../animations/behaviors/InvertChildrenTransformBehavior');
const getSizeMode = require('../utils/getSizeMode');

const JSONStorage = require('../../../viscomjs/load/JSONStorage');
const storage = JSONStorage.instance();

const MouseInteractionSingleton = require('../../../viscomjs/interactions/MouseInteractionSingleton');
const interactionController = MouseInteractionSingleton({center: {x: 0.5, y: 0.75}});

// const videoBg = require('./js/viscom/google/surviver/videoBg');

const mainVPRoot = document.querySelector('#mainVP');
const mainVPs = [...document.querySelectorAll('#mainVP div')];

const startVP = document.querySelector('#startVP div');
const startBgVP1 = document.querySelector('#startBgVP1');
const startBgVP2 = document.querySelector('#startBgVP2');

const underVP = document.querySelector('#underVP div');
const underTopVP = document.querySelector('#underTopVP div');

const frontVPRoot = document.querySelector('#frontVP');
const frontVPs = [...document.querySelectorAll('#frontVP div')];
const frontTopVP = document.querySelector('#topVP div');

const bgVPRoot = document.querySelector('#bgVP');
const bgVPRoot2 = document.querySelector('#bgVP2');
const bgVPs = [...document.querySelectorAll('#bgVP div')];
const bgVPs2 = [...document.querySelectorAll('#bgVP2 div')];

const mainAnims = [];
const frontAnims = [];
const bgAnims = [];
const bgAnims2 = [];
let startAnim;
let startBgAnim1;
let startBgAnim2;
let underAnim;
let underTopAnim;
let frontTopAnim;
let tl;
const body = document.body;

const _construct = (target, data, el, ratio) => {
    if (!data) return target;

    DefaultLottieConstruct(target, data, el);

    target._resizeBehavior = ratio && typeof ratio.push === 'function' ? OrientationResizeBehavior(...[el].concat(ratio)) : DefaultResizeBehavior(el, ratio);

    return target;
};

const _constructStart = (target, data, el, ratio) => {
    if (!data) return target;

    _construct(target, data, el, ratio)._renderBehavior = InvertChildrenTransformBehavior(el, 'svg > g > g:first-of-type', 0, 28);

    return target;
};

const _constructBack = (target, data, el, ratio, scales) => {
    if (!data) return target;

    _construct(target, data, el, ratio)._resizeBehavior =
        (ratio && typeof ratio.push === 'function') || scales
            ? OrientationResizeBehavior(...[el].concat(ratio).concat(scales))
            : DefaultResizeBehavior(el, ratio);

    return target;
};

const __defaultSetAnim = (data, vp, ratio) => {
    const anim = AnimationPlayer(target => _construct(target, data, vp, ratio));
    anim.init();
    anim.start();
    return anim;
};

/* Utils */
const __addVPLayer = (root, arr) => {
    const div = document.createElement('DIV');
    div.style.display = 'none';
    // root.appendChild(div);
    root.insertBefore(div, root.firstChild);
    arr.push(div);
};

const __removeFirstVPLayer = arr => {
    const div = arr.shift();
    if (div.parentNode) div.parentNode.removeChild(div);
};

const __clearUpSVGRootClipPath = el => {
    const g = el.querySelector('svg > g');
    if (!g) return;
    g.removeAttribute('clip-path');
};
/* /Utils */

/* BG */
const __setBgAnim = location => {
    let n = 1;
    if (location === 'river') n = 2;
    __addVPLayer(bgVPRoot, bgVPs);
    let bgAnim = AnimationPlayer(target => BgConstruct(target, location, n, bgVPs[bgVPs.length - 1], _bgRatios[location], _bgScales[location]));
    bgAnim.init();
    bgAnim.start();
    bgAnims.push(bgAnim);

    if (location === 'mountains') {
        __addVPLayer(bgVPRoot2, bgVPs2);
        bgAnim = AnimationPlayer(target =>
            _constructBack(target, storage.getJSON(location + '_back'), bgVPs2[bgVPs2.length - 1], _bgRatios[location], _bgScales[location])
        );
        bgAnim.init();
        bgAnim.start();
        bgAnims2.push(bgAnim);
    } else {
        bgAnims2.push(null);
    }
};

const __playBgAnim = (from, to) => {
    if (bgAnims.length < 1) return;
    const bgAnim = bgAnims[bgAnims.length - 1];

    const div = bgVPs[bgVPs.length - 1];
    div.style.display = 'block';

    bgAnim.playFromTo(from, to);
};

const __playBgAnim2 = (fromTo, loopFromTo) => {
    if (bgAnims2.length < 1) return;
    const bgAnim = bgAnims2[bgAnims2.length - 1];

    const div = bgVPs2[bgVPs2.length - 1];
    div.style.display = 'block';

    if (fromTo.length < 1) {
        return;
    }

    const arr = fromTo.shift();
    if (arr.length < 2) {
        __playBgAnim2(fromTo, loopFromTo);
        return;
    }
    bgAnim.playFromTo(arr[0], arr[1]).then(() => {
        if (fromTo.length > 0) {
            __playBgAnim2(fromTo, loopFromTo);
        }
    });
};

const __destroyFirstBgAnim = checkMoreThenOne => {
    if ((checkMoreThenOne && bgAnims.length < 2) || bgAnims.length < 1) return;

    let bgAnim = bgAnims.shift();
    bgAnim.destroy();
    __removeFirstVPLayer(bgVPs);

    bgAnim = bgAnims2.shift();
    if (!bgAnim) return;

    bgAnim.destroy();
    __removeFirstVPLayer(bgVPs2);
};
/* /BG */

/* MAIN */
const __setMainAnim = (data, ratio) => {
    __addVPLayer(mainVPRoot, mainVPs);

    mainAnims.push(__defaultSetAnim(data, mainVPs[mainVPs.length - 1], ratio));
};

const __playMainAnim = (fromTo, loopFromTo, isLast) => {
    if (mainAnims.length < 1) return;
    const mainAnim = mainAnims[mainAnims.length - 1];

    const div = mainVPs[mainVPs.length - 1];
    div.style.display = 'block';

    if (fromTo.length < 1) {
        __playLoopMainAnim(loopFromTo, isLast);
        return;
    }

    const arr = fromTo.shift();
    if (arr.length < 2) {
        __playMainAnim(fromTo, loopFromTo, isLast);
        return;
    }
    body.dataset.storyAnimation = typeof arr[arr.length - 1] === 'boolean' ? arr[arr.length - 1] : false;
    mainAnim.playFromTo(arr[0], arr[1]).then(() => {
        if (fromTo.length > 0) {
            __playMainAnim(fromTo, loopFromTo, isLast);
            return;
        }
        __playLoopMainAnim(loopFromTo, isLast);
    });
};

const __playLoopMainAnim = (loopFromTo, isLast) => {
    body.dataset.storyAnimation = isLast;

    const div = mainVPs[mainVPs.length - 1];
    div.style.display = 'block';

    if (mainAnims.length < 1) return;
    const mainAnim = mainAnims[mainAnims.length - 1];
    if (loopFromTo && loopFromTo.length > 1) mainAnim.loopFromTo(loopFromTo[0], loopFromTo[1]);
};

const __destroyFirstMainAnim = checkMoreThenOne => {
    if ((checkMoreThenOne && mainAnims.length < 2) || mainAnims.length < 1) return;

    const mainAnim = mainAnims.shift();
    mainAnim.destroy();
    __removeFirstVPLayer(mainVPs);
};
/* /MAIN */

/* START BG */
const __setStartBgAnim = (data1, data2) => {
    startBgAnim1 = __defaultSetAnim(data1, startBgVP1);
    startBgAnim2 = __defaultSetAnim(data2, startBgVP2);
};

const __playLoopStartBg = (loopFrom, loopTo) => {
    startBgVP1.style.display = 'block';
    startBgVP2.style.display = 'block';
    startBgAnim1.loopFromTo(loopFrom, loopTo);
    startBgAnim2.loopFromTo(loopFrom, loopTo);
};

const __destroyStartBgAnim = () => {
    if (startBgAnim1) startBgAnim1.destroy();
    if (startBgAnim2) startBgAnim2.destroy();
    startBgAnim1 = null;
    startBgAnim2 = null;
};
/* /START BG */

/* START */
const __setStartAnim = data => {
    if (startAnim) return;
    startAnim = AnimationPlayer(target => _constructStart(target, data, startVP));
    startAnim.init();
    startAnim.start();

    __clearUpSVGRootClipPath(startVP);
};

const __playStartAnim = (from, to, loopFrom, loopTo, onComplete) => {
    if (!startAnim) return;
    startAnim.playFromTo(from, to).then(() => {
        __loopStartAnim(loopFrom, loopTo);
        onComplete();
    });
};

const loopD = 4;
const deltaR = 10;
const R0 = 36.3527;
const Rmin = -4.6894;
const Rmax = 180;
const Tmin = 10;
const Tmax = 13;
const T2Start = 14;
let R = R0;
let rRounded = R0;

const __getTByR = r => Tmin + ((Tmax - Tmin) * (r - Rmin)) / (Rmax - Rmin);

const __gotoRotationStartAnim = (value, duration = 0.15) => {
    if (!startAnim) return;
    if (value === R) return;
    if (value > Rmax || value < Rmin) return;

    TweenMax.killDelayedCallsTo(__tweenToRotationStartAnim);

    const prevT = __getTByR(R);
    const t0 = __getTByR(value);
    let t1 = t0;

    let n = value / deltaR;
    if (value > R) n = Math.ceil(n);
    else n = Math.floor(n);

    const r = Math.min(Rmax, Math.max(0, n * deltaR));
    t1 = __getTByR(r);

    const t2 = T2Start + loopD * n;

    R = value;
    rRounded = r;

    startAnim.tweenFromTo(prevT, t0, duration, Linear.easeInOut).then(() => {
        TweenMax.delayedCall(0.005, __tweenToRotationStartAnim, [t0, t1, t2, t2 + loopD - 0.1]);
    });
};

const __tweenToRotationStartAnim = (from, to, loopFrom, loopTo) => {
    if (!startAnim) return;
    startAnim.tweenFromTo(from, to, 0.25).then(() => {
        R = rRounded;
        __loopStartAnim(loopFrom, loopTo);
    });
};

const __loopStartAnim = (loopFrom, loopTo) => {
    if (!startAnim) return;
    if (loopFrom !== void 0 && loopTo !== void 0) startAnim.loopFromTo(loopFrom, loopTo);
};

const __destroyStartAnim = () => {
    if (!startAnim) return;
    startAnim.destroy();
    startAnim = null;
};

const __onInteraction = () => {
    let a = (interactionController.rotation * 180) / Math.PI;
    if (a > 90) a -= 360;
    a += 180;
    __gotoRotationStartAnim(a);
};

const __startUInteraction = () => {
    interactionController.on('update', __onInteraction);
    interactionController.start();
};

const __stopUInteraction = () => {
    interactionController.off('update', __onInteraction);
    interactionController.stop();
};
/* /START */

/* UNDER */
const __setUnderAnim = data => {
    underAnim = __defaultSetAnim(data, underVP);
};

const __setUnderTopAnim = data => {
    underTopAnim = __defaultSetAnim(data, underTopVP);
};

const __destroyUnderAnim = () => {
    if (!underAnim) return;
    underAnim.destroy();
    underAnim = null;
};

const __destroyUnderTopAnim = () => {
    if (!underTopAnim) return;
    underTopAnim.destroy();
    underTopAnim = null;
};

/* /UNDER */

/* FRONT */
const __setFrontAnim = data => {
    __addVPLayer(frontVPRoot, frontVPs);
    const frontAnim = __defaultSetAnim(data, frontVPs[frontVPs.length - 1], [0.6, 0.75]);

    frontAnims.push(frontAnim);
};

const __playFrontAnim = (from, to, loopFrom, loopTo) => {
    if (frontAnims.length < 1) return;
    const frontAnim = frontAnims[frontAnims.length - 1];

    const div = frontVPs[frontVPs.length - 1];
    div.style.display = 'block';

    frontAnim.playFromTo(from, to).then(() => {
        if (loopFrom !== void 0 && loopTo !== void 0) frontAnim.loopFromTo(loopFrom, loopTo);
    });
};

const __destroyFirstFrontAnim = checkMoreThenOne => {
    if ((checkMoreThenOne && frontAnims.length < 2) || frontAnims.length < 1) return;

    const frontAnim = frontAnims.shift();
    frontAnim.destroy();
    __removeFirstVPLayer(frontVPs);
};
/* /FRONT */

/* FRONT TOP */
const __setFrontTopAnim = data => {
    frontTopAnim = __defaultSetAnim(data, frontTopVP);
};

const __destroyFrontTopAnim = () => {
    if (!frontTopAnim) return;
    frontTopAnim.destroy();
    frontTopAnim = null;
};
/* /FRONT TOP */

const __newTL = controller => {
    return new TimelineMax({
        onStart: () => {
            controller.emit('transitionStart');
        },
        onComplete: () => {
            controller.emit('transitionEnd');
        }
    });
};

const _ratios = {
    forest: [0.5, 0.6],
    mountains: 0.7,
    river: 0.75
};

const _bgRatios = {
    forest: [0.5, 0.6],
    mountains: [0.7, 0.28],
    river: [0.75, 0.28]
};

const _bgScales = {
    forest: [],
    mountains: [1, 1.07],
    river: [1, 1.07]
};

let locationId = null;

module.exports = () => {
    const controller = new EventEmitter();
    controller.setup = () => {};
    controller.startCover = () => {
        if (tl) tl.kill();
        // TODO: destroy results animation if there is some

        tl = __newTL(controller);
        tl.call(__destroyFirstFrontAnim);
        tl.call(() => {
            __setFrontAnim(storage.getJSON('start_front'));
            __setStartAnim(storage.getJSON('start'));
            __setStartBgAnim(storage.getJSON('start_forest_l1'), storage.getJSON('start_forest_l2'));
            __setUnderAnim(storage.getJSON('bottom_1'));
            __setUnderTopAnim(storage.getJSON('top_1'));
        });
        tl.call(() => {
            // videoBg.start();
            __playFrontAnim(0, 0.1, 0.1, 6.7);
            __playLoopStartBg(0, 16);
            __playStartAnim(8.7, 9.9, 6, 9.9, () => {
                if (getSizeMode() !== 'default') __gotoRotationStartAnim(0, 0.45);
                __startUInteraction();
            });
            underAnim.play();
            underTopAnim.playFromTo(0, 2).then(() => {
                underTopAnim.loopFromTo(2, 14);
            });
        });
        tl.call(__destroyFrontTopAnim);
        tl.call(() => {
            controller.emit('transitionMiddle');
        });
        tl.to('#fade', 0.4, {
            opacity: 0
        });

        locationId = null;

        return tl;
    };

    /* gotoIntro: () => {
        if (tl) tl.kill();

        tl.to('#fade', 0.15, {
            opacity: 1
        });
        tl = __newTL(controller);
        tl.call(__stopUInteraction);
        tl.call(__setMainAnim, [storage.getJSON('intro'), _ratios['intro']]);
        tl.call(() => {
            __playMainAnim(0, 0.1, 0.1, 4);
            __playFrontAnim(7, 7.1, 7.1, 13.7);
        });
        tl.call(__destroyFirstMainAnim, [true]);
        tl.call(__destroyFirstBgAnim, [true]);
        tl.call(__destroyFirstFrontAnim, [true]);
        tl.call(__destroyStartAnim);
        tl.call(__destroyStartBgAnim);
        tl.call(__destroyUnderAnim);
        tl.call(__destroyUnderTopAnim);
        tl.to('#fade', 0.25, {
            opacity: 0
        });

        return tl;
    },*/

    controller.gotoResults = () => {
        if (tl) tl.kill();
        tl = __newTL(controller);

        locationId = null;

        tl.to('#fade', 0.2, {
            opacity: 1
        });
        tl.call(__stopUInteraction);
        tl.call(__setFrontTopAnim, [storage.getJSON('top_1')]);
        tl.call(__setFrontAnim, [storage.getJSON('bottom_1')]);
        tl.call(() => {
            // videoBg.stop();
            frontTopAnim.play();
            __playFrontAnim(0, 2, 2, 14);
        });
        tl.call(__destroyFirstFrontAnim, [true]);
        tl.call(__destroyFirstMainAnim);
        tl.call(__destroyFirstBgAnim);
        tl.call(() => {
            controller.emit('transitionMiddle');
        });
        tl.to('#fade', 0.25, {
            opacity: 0
        });

        return tl;
    };

    controller.gotoLocation = (id, from) => {
        if (tl) tl.kill();
        tl = __newTL(controller);

        if (id === locationId) return tl;

        tl.call(__stopUInteraction);

        switch (id) {
            // case 'forest':
            // TODO: Eyes transition animation
            //     break;
            default:
                tl.call(__setBgAnim, [id]);
                tl.call(__setMainAnim, [storage.getJSON(id), _ratios[id]]);
                tl.call(__setFrontAnim, [storage.getJSON(id + '_front')]);
                tl.to('#fade', 0.3, {
                    opacity: 1
                });
                tl.call(() => {
                    __playBgAnim(0, 0.5);
                    __playMainAnim([0, 0.01]);
                    __playFrontAnim(0, 0.1, 0.1, 7);
                });
                tl.call(() => {
                    switch (from) {
                        case 'cover':
                            __destroyStartAnim();
                            __destroyStartBgAnim();
                            __destroyFirstFrontAnim(true);
                            __destroyUnderAnim();
                            __destroyUnderTopAnim();
                            break;
                        case 'results':
                            __destroyFirstFrontAnim(true);
                            __destroyFrontTopAnim();
                            break;
                        case 'question':
                        case 'answer':
                            __destroyFirstMainAnim(true);
                            __destroyFirstBgAnim(true);
                            __destroyFirstFrontAnim(true);
                            break;
                    }
                });
                tl.call(() => {
                    controller.emit('transitionMiddle');
                });
                tl.to('#fade', 0.4, {
                    opacity: 0
                });
                break;
        }

        locationId = id;

        return tl;
    };

    controller.prepareShortStory = (id, tl, lastAnswer) => {
        switch (id) {
            case 'fire':
                tl.call(() => {
                    __playBgAnim(1, 1.5);
                    // __playLoopMainAnim([0, 4]);
                    __playMainAnim([[0, 4, true]], [4, 8]);
                });

                break;

            case 'food':
                tl.addLabel('story');
                tl.call(
                    () => {
                        switch (lastAnswer) {
                            case 'fire_0':
                                __playMainAnim([[4 + 4, 8 + 4, true], [20 + 4, 22 + 4, true]], [22 + 4, 26 + 4]);
                                break;
                            case 'fire_1':
                                __playMainAnim([[4 + 4 + 5, 8 + 4 + 5, true], [20 + 4, 22 + 4, true]], [22 + 4, 26 + 4]);
                                break;
                            default:
                                __playMainAnim([[4 + 4 + 10, 8 + 4 + 10, true], [20 + 4, 22 + 4, true]], [22 + 4, 26 + 4]);
                                break;
                        }
                    },
                    [],
                    this,
                    'story'
                );
                tl.call(
                    () => {
                        __playBgAnim(2, 2.5);
                        __playFrontAnim(7, 9, 9, 14);
                    },
                    [],
                    this,
                    'story+=' + 3.8
                );
                break;

            case 'bear':
                tl.addLabel('story');
                tl.call(
                    () => {
                        switch (lastAnswer) {
                            case 'food_0':
                                __playMainAnim([[26 + 4, 30 + 4, true], [42 + 4, 44 + 4, true]], [44 + 4, 48 + 4]);
                                break;
                            case 'food_1':
                                __playMainAnim([[26 + 4 + 5, 30.5 + 4 + 5, true], [42 + 4, 44 + 4, true]], [44 + 4, 48 + 4]);
                                break;
                            default:
                                __playMainAnim([[26 + 4 + 10, 30.5 + 4 + 10, true], [42 + 4, 44 + 4, true]], [44 + 4, 48 + 4]);
                                break;
                        }
                    },
                    [],
                    this,
                    'story'
                );
                tl.call(
                    () => {
                        __playBgAnim(3, 3.5);
                        __playFrontAnim(14, 15, 15, 21);
                    },
                    [],
                    this,
                    'story+=' + (lastAnswer !== 'food_0' ? 4.3 : 3.8)
                );
                break;

            case 'chilblain':
                tl.call(() => {
                    __playBgAnim(1, 1.5);
                    __playLoopMainAnim([0, 4]);
                    __playFrontAnim(0, 0.1, 0.1, 7);
                });
                break;

            case 'injury':
                tl.addLabel('story');
                tl.call(
                    () => {
                        switch (lastAnswer) {
                            case 'chilblain_0':
                                __playMainAnim([[4, 8, true], [20, 22, true]], [22, 26]);
                                // __playBgAnim2([[4, 8, true], [20, 22, true]], [22, 26]);
                                break;
                            case 'chilblain_1':
                                __playMainAnim([[4 + 5, 8 + 5, true], [20, 22, true]], [22, 26]);
                                // __playBgAnim2([[4 + 5, 8 + 5, true], [20, 22, true]], [22, 26]);
                                break;
                            default:
                                __playMainAnim([[4 + 10, 8.5 + 10, true], [20, 22, true]], [22, 26]);
                                // __playBgAnim2([[4 + 10, 8.5 + 10, true], [20, 22, true]], [22, 26]);
                                break;
                        }
                    },
                    [],
                    this,
                    'story'
                );
                tl.call(
                    () => {
                        __playBgAnim(2, 2.5);
                        __playFrontAnim(7, 8, 8, 14);
                    },
                    [],
                    this,
                    'story+=' + (lastAnswer === 'chilblain_2' ? 4.3 : 3.8)
                );
                break;

            case 'lost':
                tl.addLabel('story');
                tl.call(
                    () => {
                        switch (lastAnswer) {
                            case 'injury_0':
                                __playMainAnim([[26, 30, true], [42, 44, true]], [44, 48]);
                                __playBgAnim2([[26, 30, true], [42, 44, true]], [44, 48]);
                                break;
                            case 'injury_1':
                                __playMainAnim([[26 + 5, 30 + 5, true], [42, 44, true]], [44, 48]);
                                __playBgAnim2([[26 + 5, 30 + 5, true], [42, 44, true]], [44, 48]);
                                break;
                            default:
                                __playMainAnim([[26 + 10, 30.5 + 10, true], [42, 44, true]], [44, 48]);
                                __playBgAnim2([[26 + 10, 30.5 + 10, true], [42, 44, true]], [44, 48]);
                                break;
                        }
                    },
                    [],
                    this,
                    'story'
                );
                tl.call(
                    () => {
                        __playBgAnim(3, 3.5);
                        __playFrontAnim(14, 15, 15, 21);
                    },
                    [],
                    this,
                    'story+=' + (lastAnswer === 'injury_2' ? 4.3 : 3.8)
                );
                break;

            case 'spasm':
                tl.call(() => {
                    __playBgAnim(1, 1.5);
                    __playMainAnim([[0, 2]], [2, 6]);
                    __playFrontAnim(0, 0.1, 0.1, 7);
                });
                break;

            case 'maelstrom':
                tl.addLabel('story');
                tl.call(
                    () => {
                        switch (lastAnswer) {
                            case 'spasm_0':
                                __playMainAnim([[4 + 2, 8 + 2, true], [20 + 2, 22 + 2, true]], [22 + 2, 26 + 2]);
                                break;
                            case 'spasm_1':
                                __playMainAnim([[4 + 2 + 5, 8 + 2 + 5, true], [20 + 2, 22 + 2, true]], [22 + 2, 26 + 2]);
                                break;
                            default:
                                __playMainAnim([[4 + 2 + 10, 8 + 2 + 10, true], [20 + 2, 22 + 2, true]], [22 + 2, 26 + 2]);
                                break;
                        }
                    },
                    [],
                    this,
                    'story'
                );
                tl.call(
                    () => {
                        __playBgAnim(2, 2.5);
                        __playFrontAnim(7, 8, 8, 14);
                    },
                    [],
                    this,
                    'story+=' + 3.8
                );
                break;

            case 'fishing':
                tl.addLabel('story');
                tl.call(
                    () => {
                        switch (lastAnswer) {
                            case 'maelstrom_0':
                                __playMainAnim([[26 + 2, 30 + 2, true], [42 + 1, 44 + 1, true]], [44 + 1, 48 + 1]);
                                break;
                            case 'maelstrom_1':
                                __playMainAnim([[26 + 2 + 5, 30 + 2 + 5, true], [42 + 1, 44 + 1, true]], [44 + 1, 48 + 1]);
                                break;
                            default:
                                __playMainAnim([[26 + 2 + 10, 30 + 2 + 10, true], [42 + 1, 44 + 1, true]], [44 + 1, 48 + 1]);
                                break;
                        }
                    },
                    [],
                    this,
                    'story'
                );
                tl.call(
                    () => {
                        __playBgAnim(3, 3.5);
                        __playFrontAnim(14, 15, 15, 21);
                    },
                    [],
                    this,
                    'story+=' + 3.8
                );
                break;
        }
    };

    controller.showShortStory = (id, lastAnswer) => {
        switch (id) {
            case 'bear':
                switch (lastAnswer) {
                    default:
                        switch (lastAnswer) {
                            case 'bear_0':
                                __playMainAnim([[48 + 4, 52 + 4, true]], null, true);
                                break;
                            case 'bear_1':
                                __playMainAnim([[48 + 4 + 5, 52 + 4 + 5, true]], null, true);
                                break;
                            default:
                                __playMainAnim([[48 + 4 + 10, 52 + 4 + 10, true]], null, true);
                                break;
                        }
                        break;
                }
                break;

            case 'lost':
                switch (lastAnswer) {
                    default:
                        switch (lastAnswer) {
                            case 'lost_0':
                                __playMainAnim([[48, 52, true]], null, true);
                                __playBgAnim2([[48, 52, true]], null, true);
                                break;
                            case 'lost_1':
                                __playMainAnim([[48.5 + 5, 52 + 5, true]], null, true);
                                __playBgAnim2([[48.5 + 5, 52 + 5, true]], null, true);
                                break;
                            default:
                                __playMainAnim([[48.5 + 10, 52 + 10, true]], null, true);
                                __playBgAnim2([[48.5 + 10, 52 + 10, true]], null, true);
                                break;
                        }
                        break;
                }
                break;

            case 'fishing':
                switch (lastAnswer) {
                    default:
                        switch (lastAnswer) {
                            case 'fishing_0':
                                __playMainAnim([[48 + 1, 52 + 1, true]], null, true);
                                break;
                            case 'fishing_1':
                                __playMainAnim([[48 + 1 + 5, 52 + 1 + 5, true]], null, true);
                                break;
                            default:
                                __playMainAnim([[48 + 1 + 10, 52 + 1 + 10, true]], null, true);
                                break;
                        }
                        break;
                }
                break;
        }
    };

    return controller;
};
